const PREVIEW_STATES = {
  upgrade: {
    entitlement: { active: false, mode: null, status: null },
    trial: null,
    usage: null
  },
  trial: {
    entitlement: { active: false, mode: null, status: null },
    trial: {
      active: true,
      remainingDays: 5,
      totalDays: 7,
      beginAt: '2026-01-01T00:00:00.000Z'
    },
    usage: null
  },
  trialEnded: {
    entitlement: { active: false, mode: null, status: null },
    trial: {
      active: false,
      remainingDays: 0,
      totalDays: 7,
      beginAt: '2026-01-01T00:00:00.000Z',
      endedAt: '2026-01-08T00:00:00.000Z'
    },
    usage: null
  },
  usage: {
    entitlement: { active: false, mode: null, status: null },
    trial: {
      active: false,
      remainingDays: 0,
      totalDays: 7,
      beginAt: '2026-01-01T00:00:00.000Z',
      endedAt: '2026-01-08T00:00:00.000Z'
    },
    usage: {
      feature: 'pro',
      configured: true,
      available: true,
      hit: false,
      remaining: 42
    }
  },
  manage: {
    entitlement: { active: true, mode: 'subscription', status: 'active' },
    trial: null,
    usage: null
  }
}

function createPreviewClient ({ entitlement, trial, usage }) {
  return {
    accountId: 'dashboard-preview',
    apiUrl: 'https://api.payhook.link',
    testMode: false,
    getEntitlement: () => entitlement,
    getTrialState: () => trial,
    getFeatureUsageState: () => usage,
    onEntitlementChange: () => () => {},
    onTrialChange: () => () => {},
    onFeatureUsageChange: () => () => {},
    getPaymentHookId: async () => null,
    resolveEmail: async () => null,
    openManagePlan: async () => {},
    pull: async () => []
  }
}

export function mountSdkButtonPreview ({ UpgradeButton, roots, labels = {} }) {
  if (typeof UpgradeButton !== 'function') return null
  if (!roots || Object.keys(PREVIEW_STATES).some((key) => !roots[key])) return null

  const buttons = {}

  try {
    Object.entries(PREVIEW_STATES).forEach(([key, state]) => {
      const button = new UpgradeButton(createPreviewClient(state), { labels })

      // Dashboard previews must not count as customer button loads.
      button._didTrackLoad = true
      button.mount(roots[key])
      roots[key].setAttribute('inert', '')
      buttons[key] = button
    })
  } catch (error) {
    Object.values(buttons).forEach((button) => button.destroy?.())
    throw error
  }

  return {
    updateLabels (nextLabels = {}) {
      Object.values(buttons).forEach((button) => {
        button.labels = { ...button.labels, ...nextLabels }
        button._render()
      })
    },
    destroy () {
      Object.entries(buttons).forEach(([key, button]) => {
        button.destroy?.()
        roots[key].removeAttribute('inert')
      })
    }
  }
}
